import Field from './Field'

export default function FieldHidden (label, key, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'hidden'
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldHidden.js